import { ThemeUICSSObject } from '@apia/theme';
import components from './components';
import entity from './entity';
import form from './form';
import tabs from './tabs';
import taskResult from './taskResult';
import reports from './reports';
/* IMPORT HERE */
const execution: ThemeUICSSObject = {
  components,
  form,
  entity,
  tabs,
  taskResult,
  reports,
  /* PREPEND HERE */
};

export default execution;
